//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'

export default {
    name: 'editUser',
    components: {
        wx
    },
    data() {
        return {
            filePath: '',
            title:'',
            content:'',
            pic:''
        }
    },
    created() {
        this.config();
        this.getInfo();
    },
    computed:{

    },
    methods: {
         getInfo(){
            this.$api.getInfo({}).then((res)=>{
                if(res){
                    this.title = res.data.title;
                    this.filePath = res.data.pic_path;
                    this.content = res.data.content;
                    this.pic = res.data.pic;
                }
            })
        },
        submit() {
            if(!this.title){
                this.$func.showToast('请输入店名');
                return false;
            }
            if(!this.content){
                this.$func.showToast('请输入站点描述');
                return false;
            }
            if(!this.filePath){
                this.$func.showToast('请上传门面图');
                return false;
            }
            this.$api.submitCommunity({title:this.title,content:this.content,filePath:this.filePath}).then((res)=>{
                this.$func.showToast('提交成功');
            });
        },
        config(){
            // var url= '';
            // var u = navigator.userAgent;
            // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            // if (isIOS) {
            //     url=window.entryUrl
            // }else{
            //     url = window.location.href;
            // }
             let url = (window.location.href).split('#');
            if(url[0].indexOf('?') != '-1'){
                url = url[0].split('?');
            }
            this.$api.wxSign({url:url[0]}).then((res)=>{
                if(res){
                    wx.config({
                        debug: false, //调试阶段建议开启
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature:res.data.signature,
                        jsApiList: [
                            "chooseImage",
                            "uploadImage",
                        ]
                    });
                }
            })
        },
        uploadFile(){
            let that = this;
            wx.chooseImage({
                    count: 1,
                    sizeType: ['original', 'compressed'], 
                    sourceType: ['album', 'camera'], 
                    success: function (res) {
                        that.uploadImg(res.localIds);
                    }
                });
            },
        uploadImg(localIds){
            let localId = localIds.pop();
            let that = this;
            wx.uploadImage({
                localId: localId, 
                success: function (res) {
                that.$api.uploadsImg({serverId:res.serverId,path:'product'}).then((res)=>{
                    if(res){
                        that.filePath = res.data.url;
                        that.pic = res.data.path;
                    }
                })
                }
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/pages/editUser.vue